<div class="card-primary">
  <h2 mat-dialog-title>
    {{ 'home.first-login-dialog.title' | translate | capitalize }}
  </h2>
  <p>{{ 'home.first-login-dialog.description' | translate }}</p>
  <form [formGroup]="registerForm">
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>{{ 'account.email' | translate | capitalize }}</mat-label>
      <input formControlName="email" matInput />
    </mat-form-field>
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>{{ 'account.firstname' | translate | capitalize }}</mat-label>
      <input formControlName="firstname" matInput />
      @if (registerForm.get('firstname')?.hasError('required')) {
        <mat-error>{{ 'general.inputs.errors.required' | translate | capitalize }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>{{ 'account.lastname' | translate | capitalize }}</mat-label>
      <input formControlName="lastname" matInput />
      @if (registerForm.get('lastname')?.hasError('required')) {
        <mat-error>{{ 'general.inputs.errors.required' | translate | capitalize }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>{{ accountNumberText }}</mat-label>
      <input formControlName="studentNumber" matInput />
    </mat-form-field>
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>{{ 'home.first-login-dialog.choose-group' | translate | capitalize }}</mat-label>
      <mat-select formControlName="group" (selectionChange)="onGroupChange($event)">
        @for (group of groups; track group) {
          <mat-option
            [disabled]="group.maxStudents <= group.studentCount"
            [matTooltipDisabled]="group.maxStudents > group.studentCount"
            matTooltipPosition="left"
            [matTooltip]="'home.first-login-dialog.max-students-in-group' | translate | capitalize"
            [value]="group"
            >{{ group.name }}</mat-option
          >
        }
      </mat-select>
      @if (registerForm.get('group')?.hasError('required')) {
        <mat-error>{{ 'general.inputs.errors.required' | translate | capitalize }}</mat-error>
      }
    </mat-form-field>
    @if (registerForm.get('group')!.value && registerForm.get('group')!.value.pin) {
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>{{ groupPinText }}</mat-label>
        <input formControlName="groupPin" matInput />
        @if (registerForm.get('groupPin')?.hasError('required')) {
          <mat-error>{{ 'general.inputs.errors.required' | translate | capitalize }}</mat-error>
        }
      </mat-form-field>
    }
    <app-spinner-button
      [config]="btnConfig"
      style="margin-top: 5px"
      (onClick)="save()"
      [disabled]="registerForm.invalid"></app-spinner-button>
  </form>
</div>
